const ServiceInfo = () => {
  return (
    <div style={{ textAlign: "center" }} className="align-self-center mb-5">
      <p
        style={{
          fontWeight: 400,
          fontSize: "16px",
          lineHeight: "26px",
          fontFamily: "Poppins",
          color: "#FF5757",
        }}>
        OUR SERVICES
      </p>
      <p
        style={{
          fontWeight: 600,
          fontSize: "36px",
          lineHeight: "46px",
          fontFamily: "Plus Jakarta Sans",
        }}>
        How can we help you?
      </p>
    </div>
  );
};

export default ServiceInfo;
